import { render, staticRenderFns } from "./boundaryMsg.vue?vue&type=template&id=dbdbe516&"
import script from "./boundaryMsg.vue?vue&type=script&lang=js&"
export * from "./boundaryMsg.vue?vue&type=script&lang=js&"
import style0 from "./boundaryMsg.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports